import styles from './style.module.css'
import { Link } from 'react-router-dom';
import Moment from 'react-moment';
import 'moment/locale/ru';


const SchoolCard = ({
    date,
    title,
    is_active,
    managements,
    season_number,
    program,
    school_link
}
) => {
    return (
        <div className={styles.schools__area}>
            <div className={styles.card + ' ' + (is_active ? styles.active : '')}>
                <div className={styles.col}>
                    <div className={styles.title}>Дата: </div>
                    <div className={styles.content}>
                        <Moment format="DD.MM.YYYY">
                            {date}
                        </Moment>
                    </div>
                </div>
                <div className={styles.col}>
                    <div className={styles.title}>Наименование: </div>
                    <div className={styles.content}>{title}</div>
                </div>
                <div className={styles.col}>
                    <div className={styles.title}>Руководители: </div>
                    <div className={styles.content}>{managements}</div>
                </div>

                <div className={styles.description}>
                    <div className={styles.col}>
                        <div className={styles.title}>Сезон: </div>
                        <div className={styles.content}>№{season_number}</div>
                    </div>
                    {school_link && <div className={styles.col} style={{display: 'flex', justifyContent: 'center'}}>
                        <a target='_blank' href={school_link}><div className={styles.btn_school}>ПЕРЕЙТИ К ШКОЛЕ</div></a>
                    </div>}
                </div>
                {program &&
                    <div className={styles.col}>
                        <><div className={styles.title}>Программа: </div>
                            <div className={styles.content}><Link to={program}>Скачать</Link></div>
                        </>
                    </div>
                }
            </div>
        </div>
    );
}

export default SchoolCard;